/**
 * Selective ECharts factory — registers only the chart types and components
 * used in this application, reducing bundle size vs the full `import("echarts")`.
 *
 * Add imports here if new chart types or ECharts components are introduced.
 * Pass this function to provideEchartsCore({ echarts: echartsFactory }).
 */
export async function echartsFactory() {
  const echarts = await import("echarts/core");
  const { SVGRenderer } = await import("echarts/renderers");
  const { BarChart, LineChart, PieChart } = await import("echarts/charts");
  const {
    GridComponent,
    TooltipComponent,
    LegendComponent,
    MarkLineComponent,
  } = await import("echarts/components");

  echarts.use([
    SVGRenderer,
    BarChart,
    LineChart,
    PieChart,
    GridComponent,
    TooltipComponent,
    LegendComponent,
    MarkLineComponent,
  ]);

  return echarts;
}
